import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    Pagination,
    EditButton, Filter, ReferenceInput, AutocompleteInput, DateInput, SelectInput,
    FunctionField,
    Button,
    TextInput,
    // BooleanField,

} from 'react-admin';
import { Clear } from '@material-ui/icons';
import { connect } from 'react-redux';
import { showNotification } from 'ra-core';
import { API_BASE } from '../dataProvider';
import CustomActiveField from "../common/CustomActiveField"

const ResendPasswordButton = ({ email, dispatch }) => {
    const handleResendPassword = async (e) => {
        e.stopPropagation(); // 阻止事件冒泡，防止跳转到详情页
        try {
            const response = await fetch(`${API_BASE}/password-reset?email=${encodeURIComponent(email)}`, {
                method: 'GET',
            });
            
            if (response.ok) {
                dispatch(showNotification('Password reset link sent successfully', 'info'));
            } else {
                dispatch(showNotification('Failed to send, please try again later', 'warning'));
            }
        } catch (error) {
            dispatch(showNotification('Failed to send, please try again later', 'warning'));
        }
    };
    
    return (
        <Button 
            label="Resend Password Initial Link" 
            onClick={handleResendPassword}
            variant="contained"
            size="small"
            color="primary"
            style={{
                backgroundColor: '#1976d2',
                color: 'white',
                borderRadius: '6px',
                textTransform: 'none',
                fontSize: '12px',
                padding: '4px 12px',
                minWidth: 'auto',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                '&:hover': {
                    backgroundColor: '#1565c0',
                    boxShadow: '0 4px 8px rgba(0,0,0,0.15)'
                }
            }}
        />
    );
};

const ConnectedResendPasswordButton = connect()(ResendPasswordButton);

const PostPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />

const UserFilter = ({ permissions, ...props }) => (
    <Filter {...props}>
        <TextInput source="name" label="Username" alwaysOn />
        <TextInput source="firstName" label="First Name" alwaysOn />
        <TextInput source="lastName" label="Last Name" alwaysOn />
        <TextInput source="email" label="Email" alwaysOn />
        {permissions == "system_admin" ? (
            <ReferenceInput source="userType" label="User Type" reference="user/types" alwaysOn allowEmpty>
                <SelectInput optionText="name" />
            </ReferenceInput>
        ) : null}
        {permissions == "system_admin" || permissions == "operator" || permissions == "support" || permissions == "promoter" ? (
            <ReferenceInput source="promoter_id" reference="promoters" alwaysOn allowEmpty>
                <SelectInput optionText="name" />
            </ReferenceInput>
        ) : null}
        <Button
            label="Clear Filters"
            onClick={() => {
                // 清除所有过滤器
                props.setFilters({}, []);
            }}
            alwaysOn
        >
            <Clear />
        </Button>
    </Filter>
);

const UserList =  ({ permissions, ...props }) => (
    <List {...props} filters={permissions != "ambassador" ? <UserFilter permissions={permissions} /> : null} filterDefaultValues={{}} pagination={<PostPagination />} bulkActionButtons={false}  exporter={false} hasCreate={permissions != 'ambassador'}>
        <Datagrid rowClick={permissions != "support" && permissions != "ambassador" ? "show" : false} >
            {/* <FunctionField label="Name" render={record => `${record.firstName} ${record.lastName}`} style={{ fontWeight: 'bold' }}/> */}
            {/* <TextField source="id" label="ID" /> */}
            <TextField source="name" label="Username" />
            <FunctionField 
                label="Account Number" 
                render={record => {
                    if (record.accounts && record.accounts.accountNumber) {
                        return (
                            <a 
                                href={`#/accounts?filter={"account_number":"${record.accounts.accountNumber}"}`}
                                style={{ textDecoration: 'none', color: '#1976d2' }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                            >
                                {record.accounts.accountNumber}
                            </a>
                        );
                    }
                    return '-';
                }}
            />
            <TextField source="firstName" label="First Name" />
            <TextField source="lastName" label="Last Name" />
            <TextField source="middleName" label="Middle Name" />
            <TextField source="email" label="Email" />
            <TextField source="phoneNumber" label="Phone Number" />
            <TextField source="country" label="Country" />
            <TextField source="userType" label="Type" />
            <CustomActiveField source="active" />
            {permissions == "system_admin" || permissions == "operator"  || permissions == "support" || permissions == "promoter" ? [
                  <TextField source="promoter" label="Promoter" />
                ]:null}
            <TextField source="createDate" label="Create Date" />
            {permissions == "system_admin" || permissions == "operator"  || permissions == "support" || permissions == "promoter" ? [
            <FunctionField 
                label="Action" 
                render={record => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <ConnectedResendPasswordButton email={record.email} />
                    </div>
                )}
            />] : null}
        </Datagrid>
    </List>
);

export default UserList;
